document.addEventListener('DOMContentLoaded', () => {
  console.log('t');

(function () {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          node.tagName.toLowerCase() === "storifyme-modal"
        ) {
          const existing = document.querySelector(".storify-drag");
          if (existing) existing.remove();

          const dragEl = document.createElement("div");
          dragEl.className = "storify-drag";
          dragEl.classList.add("drag-view");
          Object.assign(dragEl.style, {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100svw",
            height: "70svh",
            zIndex: 9999999999,
            cursor: "grab",
            margin: "0 auto",
            maxWidth: "600px",
            background: "transparent",
          });

          node.insertAdjacentElement("afterend", dragEl);
          attachDragHandler(node, dragEl);
        }
      }
      for (const node of mutation.removedNodes) {
        if (
          node.nodeType === 1 &&
          node.tagName.toLowerCase() === "storifyme-modal"
        ) {
          const dragEl = document.querySelector(".storify-drag");
          if (dragEl) dragEl.remove();
        }
      }
    }
    const modalPresent = !!document.querySelector("storifyme-modal");
    const dragEl = document.querySelector(".storify-drag");
    if (modalPresent && dragEl && dragEl.style.display === "none") {
      dragEl.style.display = "flex";
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function attachDragHandler(modalEl, dragEl) {
    let startY = 0,
      currentY = 0,
      isDragging = false,
      didMove = false;
    const threshold = 120;

    const start = (e) => {
      if (!document.body.contains(modalEl)) return;
      isDragging = true;
      didMove = false;
      startY = e.touches ? e.touches[0].clientY : e.clientY;
      modalEl.style.transition = "none";
    };
    const move = (e) => {
      if (!isDragging) return;
      currentY = e.touches ? e.touches[0].clientY : e.clientY;
      const diffY = Math.max(0, currentY - startY);
      if (diffY > 10) didMove = true;
      modalEl.style.transform = `translateY(${diffY}px)`;
      modalEl.style.opacity = `${Math.max(0, 1 - diffY / 300)}`;
    };
    const end = () => {
      if (!isDragging) return;
      isDragging = false;
      const diffY = Math.max(0, currentY - startY);
      if (diffY > threshold) {
        modalEl.style.transition = "transform 0.3s ease, opacity 0.3s ease";
        modalEl.style.transform = "translateY(100%)";
        modalEl.style.opacity = "0";
        setTimeout(() => {
          modalEl.remove();
          dragEl.remove();
        }, 300);
      } else {
        modalEl.style.transition = "transform 0.2s ease";
        modalEl.style.transform = "translateY(0)";
        modalEl.style.opacity = "1";
      }
    };

    dragEl.addEventListener("mousedown", start);
    dragEl.addEventListener("mousemove", move);
    dragEl.addEventListener("mouseup", end);

    dragEl.addEventListener("touchstart", start, { passive: true });
    dragEl.addEventListener("touchmove", move, { passive: true });
    dragEl.addEventListener("touchend", end);

    // Klik lewo/prawo -> prev/next
    dragEl.addEventListener("click", (e) => {
      if (didMove) return;
      const rect = dragEl.getBoundingClientRect();
      const midX = rect.left + rect.width / 2;

      const modal = document.querySelector("storifyme-modal");
      const shadow = modal?.shadowRoot;
      const prevBtn = shadow?.querySelector(".storify-btn-prev");
      const nextBtn = shadow?.querySelector(".storify-btn-next");

      if (e.clientX < midX) {
        prevBtn?.click();
      } else {
        nextBtn?.click();
      }
    });

    // Przytrzymaj, aby pauzować / zwolnij, aby grać
    let holdTimeout,
      isHolding = false;
    const triggerPausePlay = (type) => {
      const modal = document.querySelector("storifyme-modal");
      const shadow = modal?.shadowRoot;
      const pauseBtn = shadow?.querySelector(".story-control-btn.video-pause");
      const playBtn = shadow?.querySelector(".story-control-btn.video-play");
      if (type === "pause") {
        pauseBtn?.click();
      }
      if (type === "play") {
        playBtn?.click();
      }
    };
    const onHoldStart = () => {
      isHolding = false;
      holdTimeout = setTimeout(() => {
        isHolding = true;
        triggerPausePlay("pause");
      }, 400);
    };
    const onHoldEnd = () => {
      clearTimeout(holdTimeout);
      if (isHolding) triggerPausePlay("play");
      isHolding = false;
    };

    // Desktop
    dragEl.addEventListener("mousedown", onHoldStart);
    dragEl.addEventListener("mouseup", onHoldEnd);
    dragEl.addEventListener("mouseleave", onHoldEnd);

    // Mobile
    dragEl.addEventListener("touchstart", onHoldStart, { passive: true });
    dragEl.addEventListener("touchend", onHoldEnd);
    dragEl.addEventListener("touchcancel", onHoldEnd);
  }
})();
});